const OrderConstants = Object.freeze({
    MODE_CONSEGNA: "CONSEGNA",
    MODE_RITIRO: "RITIRO",
    NO_PLATFORM: "NO",
    APP_PLATFORM: "DeliveryPro App",
    DELIVERY_COSTS: "Spese di consegna"
})

export default OrderConstants
